export default {
  CONTACT_US: 'Hubungi Kami',
  CONTACT_US_SUBTITLE:
    'Ralali siap membantu Anda mengembangkan bisnis dan mengatasi berbagai tantangan bisnis yang Anda hadapi.<br /> Tim Konsultan Bisnis kami akan segera menghubungi Anda.',
  COMPANY_INFORMATION: 'Informasi Perusahaan',
  FIND_US: 'Temukan Kami di Google Maps',
  POPULAR_PRODUCTS: 'Produk Populer',
  RECOMMENDATED_PRODUCTS: 'Rekomendasi Produk',
  RECOMMENDATED_SUPPLIERS: 'Supplier Terpercaya di Ralali',
  PARTNER_RALALI: 'Mitra Ralali',
  TRUSTED_SUPPLIERS_DESCRIPTION:
    'Temukan supplier dan distributor tersertifikasi. Dapatkan produk langsung dari tangan pertama dengan kapasitas besar dan harga terbaik.',
  LATEST_PRODUCTS: 'Produk Terbaru Ralali',
  CTA_TITLE: 'Mulai Tumbuhkan Bisnis Bersama Ralali',
  CTA_WHATSAPP: 'Hubungi via WhatsApp',
  FAQ_DEFAULT_TITLE: 'Pertanyaan yang sering kami terima',
  FAQ_SUBTITLE: 'Pertanyaan lebih lanjut? Tim Ralali siap membantu.',
  FAQ_CONTACT_TEAM: 'Hubungi Tim Kami',
  ARTICLE_EXPOSURE_LABEL: 'Eksposur Ralali',
  ARTICLE_TITLE: 'Berita dan Insight Terkini',
  SEE_ALL: 'Lihat Semua',
  PARTNERS_TITLE: 'Dipercaya oleh Mitra Bisnis Terkemuka',
  ENDS_IN: 'Berakhir Dalam:',
  HOME_H1: 'Ralali.com - Wholesale B2B Marketplace',
  SERVICES_PROMO_LABEL: 'Layanan Baru',
  SERVICES_PROMO_TITLE:
    'RalaliGrow: Scale Brand Tanpa Bangun Tim Baru',
  SERVICES_PROMO_DESC:
    'Layanan distribusi end-to-end untuk brand yang ingin tumbuh di Indonesia dan pasar internasional. Satu mitra, semua channel berjalan.',
  SERVICES_PROMO_BUTTON: 'Pelajari Selengkapnya',
  CATEGORY_EXPLORATION_LABEL: 'Eksplorasi Kategori',
  CATEGORY_EXPLORATION_TITLE: 'Temukan Solusi untuk Setiap Industri',
  CATEGORY_EXPLORATION_SUBTITLE:
    'Jelajahi ribuan produk unggulan dari berbagai sektor industri untuk memenuhi kebutuhan operasional dan supply chain bisnis Anda.',
  FAQ_LABEL: 'FAQ',
  SELLER_CERTIFIED: 'Tersertifikasi',
  SELLER_VISIT_STORE_ARIA: 'Kunjungi toko {{name}}',
  SELLER_VISIT_PARTNER_STORE_ARIA: 'Kunjungi toko mitra',
  SELLER_PRODUCT_IMAGE_ALT: 'produk',
  SERVICES_GROW_TITLE: 'RalaliGrow',
  SERVICES_GROW_DESC:
    'Kelola distribusi online dan offline tanpa bangun tim baru',
  SERVICES_PLUS_TITLE: 'RalaliPlus',
  SERVICES_PLUS_DESC:
    'Akses modal kerja dengan proses cepat dan fleksibel',
  SERVICES_FOOD_TITLE: 'Ralalifood',
  SERVICES_FOOD_DESC:
    'Nasi instan siap saji untuk bisnis dan kebutuhan harian',
  SERVICES_MBG_TITLE: 'Solusi MBG',
  SERVICES_MBG_DESC:
    'Jadi supplier resmi dari program Makan Bergizi Gratis',
}
